import { clsfy } from '../helpers'
import { useState, useEffect, useRef } from 'react'
import { Link, useHistory } from "react-router-dom"

import Sidebar from '../components/Sidebar'

const initialRoutes = () => [
	{
		path: '/',
		name: 'Home',
		icon: 'iconly-Home',
	},
	{
		path: '/profile',
		name: 'Profile',
		icon: 'iconly-Profile',
	},
	{
		name: 'Premium',
		path: '/premium',
		icon: 'iconly-Star',
	},
	{
		name: 'Settings',
		path: '/settings',
		icon: 'iconly-Setting',
	}
]

const DefaultLayout = ({ children }) => {

	const history = useHistory()
	const hoverBarRef = useRef(null)
	const activeBarRef = useRef(null)
	const [sidebarExpanded, setSidebarExpanded] = useState(false)
	const [activeRouteIndex, setActiveRouteIndex] = useState(null)
	const [routes] = useState(initialRoutes())
	const activeRoute = activeRouteIndex ? routes[activeRouteIndex] : {}

	const isActive = routeIndex => {
		return activeRouteIndex === routeIndex
	}

	const onDoneHover = () => {
		if (hoverBarRef) {
			onChangeTop(hoverBarRef, activeRouteIndex)
		}
	}

	const onChangeTop = (ref, index) => {
		ref.current.style.top = `${(index) * 44}px`;
	}

	const onRouteMouseOver = routeIndex => () => {
		if (hoverBarRef) {
			onChangeTop(hoverBarRef, routeIndex)
		}
	}

	const onRouteChange = (index, initial) => () => {
		setActiveRouteIndex(index)
		if (!initial && sidebarExpanded) {
			setSidebarExpanded(false)
		}
		if (activeBarRef) {
			onChangeTop(activeBarRef, index)
		}
	}

	const onCreated = () => {
		const { pathname } = history.location
		if (pathname !== activeRoute.path) {
			const routeIndex = routes.findIndex(r => r.path === pathname)
			onRouteChange(routeIndex, true)()
			onChangeTop(hoverBarRef, routeIndex)
		}
	}

	useEffect(() => { onCreated() })

	return (
		<div className='flex flex-col h-screen'>
			<div className='flex-1 flex bg-f4 overflow-hidden'>
				<Sidebar logoutColor='#7D8592' expanded={sidebarExpanded} onChange={v => setSidebarExpanded(v)}>
					<div className='flex flex-col relative mt-5 md:mt-6 lg:mt-7 xl:mt-8 2xl:mt-9' onMouseOut={onDoneHover}>
						<div ref={activeBarRef} className='absolute w-1 rounded-r bg-ef h-11 z-20 transition-all duration-500'></div>
						<div ref={hoverBarRef} className='absolute w-1 rounded-r bg-gray-400 z-10 h-11 transition-all duration-500'></div>
						{routes.map((route, routeIndex) => (
							<Link
								to={route.path}
								key={routeIndex}
								onClick={onRouteChange(routeIndex)}
								onMouseOver={onRouteMouseOver(routeIndex)}
								className={clsfy('px-4 lg:px-5 2xl:px-6 h-11 flex text-base transition-all ',
									'text-7d font-semibold items-center space-x-3 lg:space-x-4 duration-500', [
									isActive(routeIndex)
										? 'bg-ef bg-opacity-10 text-ef'
										: 'hover:bg-gray-100'
								])}
							>
								<i className={clsfy("text-xl", route.icon, [
									isActive(routeIndex) ? 'icbo' : 'icli'
								])}></i>
								<span>{route.name}</span>
							</Link>
						))}
					</div>
				</Sidebar>
				<div className='flex-1 flex flex-col'>
					<div className='px-5 pt-5 flex-none md:hidden'>
						<button className='rounded w-8 h-8 grid place-items-center hover:bg-ef ' onClick={() => setSidebarExpanded(true)}>
							<i className="mdi mdi-menu text-2xl text-7d hover:text-white"></i>
						</button>
					</div>
					<div className='flex-1 flex flex-col overflow-hidden lg:w-939 lg:px-8 lg:py-7 sm:px-5 sm:py-5 px-3 py-3'>
						<div className="relative">
							<input
								type="text"
								className="h-14 pr-8 z-0 focus:shadow focus:outline-none pl-10 w-full"
								placeholder="Search"
							/>
							<div className="absolute top-4 left-3">
								<span className="mdi mdi-magnify text-xl"></span>
							</div>
						</div>

						<div className='flex-1 scrollbar-y-2 pr-4 mt-5'>
							{children}
						</div>

						<div className='d-flex absolute right-4 bottom-5 md:right-10 md:bottom-10'>
							<button className="inline-flex items-center justify-center w-5 h-5 md:w-10 md:h-10 mr-2 md:mr-8  text-gray-700 transition-colors duration-150 bg-white rounded-full focus:shadow-outline hover:bg-gray-200">
								<span className="mdi mdi-help text-sm" />
							</button>
							<Link to='/editor' className="mt-4 w-36 md:w-48 h-8 md:h-12 bg-ef text-white font-bold md:py-2 px-2 md:px-4  inline-flex items-center rounded-xl">
								<span className="mdi mdi-chat-outline text-xs md:text-xl pr-1 pl-3 md:pl-2" />
								<span className='text-xs md:text-base font-bold'>New Document</span>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DefaultLayout